<ng-container [ngSwitch]="displayMode">
    <ng-container *ngSwitchCase="'slider'">
        <div class="mb-2 font-size-12">
            <div class="d-flex mb-2">
                <input [attr.id]="('module-' + stateKey + '-Settings-includeHours') | cleanId" 
                    [(ngModel)]="settingsManager.isTimeSelectorEnabled" 
                    (ngModelChange)="toggleHours()" 
                    type="checkbox" 
                    class="form-check-input ml-2 my-auto" 
                />
                <span class="ml-2" cvLocalizedText langSection="Controls" langKey="Include_Exclude_Hours">Include/Exclude Hours</span>
                <div class="ml-2" [ngbPopover]="includeExcludeHelpText" placement="bottom" triggers="mouseenter:mouseleave">
                    <svg class="icon-16 fill-valyrianSteel fill-hover-panther icon-btn">
                        <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
                    </svg>
                </div>
            </div>
            <select class="form-control form-control-lg" *ngIf="settingsManager.isTimeSelectorEnabled && dashboardService.isNewPlatform" 
            [(ngModel)]="settingsManager.invertTimeSelector" (change)="saveInvertTimeSelector()">
                <option [ngValue]="false" cvLocalizedText langSection="Controls" langKey="Include_Time">Include Time</option>
                <option [ngValue]="true" cvLocalizedText langSection="Controls" langKey="Exclude_Time">Exclude Time</option>
            </select>
        </div>
        <cv-time-slider *ngIf="settingsManager.isTimeSelectorEnabled"
            class="mb-3" 
            [isDisabled]="!settingsManager.isTimeSelectorEnabled"
            [pageName]="stateKey"
            [(startTime)]="settingsManager.minTime"
            [(endTime)]="settingsManager.maxTime"
        ></cv-time-slider>
    </ng-container>
    <div class="d-flex" *ngSwitchCase="'picker'">
        <ng-container *ngIf="!config.isCxOne">
            <select class="form-control form-control-lg" [ngClass]="(!hideDisabled || settingsManager.isTimeSelectorEnabled) ? 'w-50' : 'w-100'" *ngIf="dashboardService.isNewPlatform" [(ngModel)]="settingsManager.disableOrInvertTimeSelector" (change)="toggleHoursForPicker()">
                <option [ngValue]="null">View all hours</option>
                <option [ngValue]="false">Include hours</option>
                <option [ngValue]="true">Exclude hours</option>
            </select>
            <cv-time-picker *ngIf="!hideDisabled || settingsManager.isTimeSelectorEnabled" class="pl-3 w-25" [(ngModel)]="settingsManager.minTimeDate" [disabled]="!settingsManager.isTimeSelectorEnabled" (ngModelChange)="saveTimeSettingsDebouncer.next()"></cv-time-picker>
            <cv-time-picker *ngIf="!hideDisabled || settingsManager.isTimeSelectorEnabled" class="pl-3 w-25" [(ngModel)]="settingsManager.maxTimeDate" [disabled]="!settingsManager.isTimeSelectorEnabled" (ngModelChange)="saveTimeSettingsDebouncer.next()"></cv-time-picker>
        </ng-container>
        <ng-container *ngIf="config.isCxOne">
            <sol-dropdown [ngClass]="(!hideDisabled || settingsManager.isTimeSelectorEnabled) ? 'w-50' : 'w-100'"
                [(ngModel)]="disableOrInvertCxOne" [options]="cxOneOptions"
                (ngModelChange)="toggleHoursForPicker()"
                label="name"
                primaryKey="id"
                sortKey="order"
                [required]="false"
                [showFooter]="false"
                [searchEnabled]="false"
                ></sol-dropdown>
            
            <sol-time-picker class="pl-3 w-25"
                *ngIf="!hideDisabled || settingsManager.isTimeSelectorEnabled"
                style="font-family: 'OpenSans'"
                [steps]="15"
                [(ngModel)]="settingsManager.minTimeDate"
                (ngModelChange)="saveTimeSettingsDebouncer.next()"
                [disabled]="!settingsManager.isTimeSelectorEnabled"
                [format]="config.momentTimeFormat"
            ></sol-time-picker>
            <sol-time-picker class="pl-3 w-25"
                *ngIf="!hideDisabled || settingsManager.isTimeSelectorEnabled"
                style="font-family: 'OpenSans'"
                [steps]="15"
                [(ngModel)]="settingsManager.maxTimeDate"
                (ngModelChange)="saveTimeSettingsDebouncer.next()"
                [disabled]="!settingsManager.isTimeSelectorEnabled"
                [format]="config.momentTimeFormat"
            ></sol-time-picker>
        </ng-container>
    </div>
</ng-container>